const delete_dialog = {
	confirmation:
		"Ter bevestiging vragen wij u om de naam van uw VPS <strong>{{name}}</strong> in onderstaand invoerveld in te voeren.",
	running: {
		description:
			"Een VPS kan niet verwijderd worden wanneer de status hiervan nog actief is. Stop de VPS voordat deze verwijderd kan worden.",
		title: "Uw VPS is nog actief!",
	},
	title: "VPS verwijderen",
	warning: "Het verwijderen van een VPS is permanent en kan niet ongedaan worden gemaakt.",
};

export default delete_dialog;
